import React from 'react';

/**
 * True when this action has real check-in evidence.
 * Dev rates are usually「今月 N回」(doneCount); legacy「82%」also counts.
 * Bare「—」/ empty does not.
 */
function hasRecordSignal(action) {
  if (action?.doneCount != null && Number(action.doneCount) > 0) return true;
  const r = String(action?.rate ?? '').trim();
  if (!r || r === '—' || r === '–') return false;
  if (/^\d+(\.\d+)?%$/.test(r)) return true;
  if (/回/.test(r)) return true;
  return false;
}

/** True when this stylist has at least one recorded 行動記録 this month. */
export function hasActionRecords(actions = []) {
  return actions.some(hasRecordSignal);
}

/**
 * 📋 行動プラン — implementation rates per action.
 * Renders nothing without real check-in data.
 * `recordedDays` is the true check-in day count; omitted when unknown
 * (never substitute calendar day-of-month).
 */
export default function ActionPlanCard({ actions = [], recordedDays = null }) {
  if (!hasActionRecords(actions)) return null;

  return (
    <div className="recap">
      <div className="recap-head">
        📋 行動プラン{recordedDays != null ? ` · 記録${recordedDays}日分` : ''}
      </div>
      {actions.map((a) => (
        <div className="recap-row" key={a.id}>
          <span className="name">
            <span className="num">{a.id}</span>
            {a.name}
          </span>
          <span className={a.tone === 'warn' ? 'ans-no' : 'ans-yes'}>{a.rate || '—'}</span>
        </div>
      ))}
    </div>
  );
}
